
// Launched on Nov (11 => index in the array is 10) 20, 1998
const iss_time = (Date.now() - new Date(1998, 10, 20)) / (1000 * 60 * 60 * 24);
const ss4_time = (Date.now() - new Date(2014, 5, 19)) / (1000 * 60 * 60 * 24);
const timeSentinel6 = (Date.now() - new Date(2020, 10, 10)) / (1000 * 60 * 60 * 24);

const SPACECRAFT_DATA_AR = {
	ISS: {
		absolutePath: true,
		thumb: 'assets/images/iss_320x240.jpg',
		url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		id: 1374,
		target: '_blank',
		categories: ['operating', 'land', 'earth_now'],
		time_in_orbit: Math.floor(iss_time / 365.25) + ' سنة ميلادية و ' + Math.floor(iss_time % 365.25) + ' يوم',
		description: 'محطة الفضاء الدولية (آي اس اس) هي محطة فضائية أو قمر صناعي صالح للسكن ويقع في مدار أرضي منخفض. تم إطلاق مكونه الأول في المدار عام 1998م  مع وصول أول مقيمين إليه على المدى الطويل في شهر نوفمبر من العام 2000 م. وقد كانت المحطة مسكونة بشكل مستمر منذ ذلك التاريخ. في عام 2011 م تم تركيب آخر وحدة مضغوطة للمحطة، كما تمت إضافة مسكن فضائي تجريبي قابل للتوسع في عام 2016 م. من المتوقع أن تعمل هذه المحطة حتى عام 2030 م، مع استمرارية تطويرها وتجميعها و تصميم عدة عناصر جديدة لها، بما في ذلك فندق بقيمة 35000 دولار في الليلة الواحدة. تعد محطة الفضاء الدولية  أكبر جسم من صنع الإنسان في مدار أرضي منخفض، ويمكن غالبًا رؤيتها بالعين المجردة من الأرض. تتكون محطة الفضاء الدولية من وحدات سكنية مضغوطة و دعامات هيكلية و صفائف شمسية و أجهزة لرصد الإشعاعات و موانئ للرسو ومساحات مخصصة للتجارب وأذرع آلية. تم إطلاق مكونات محطة الفضاء الدولية بواسطة صواريخ بروتون (Proton) و سويوز (Soyuz) الروسية والسفن الفضائية الأمريكية. يعد برنامج محطة الفضاء الدولية مشروع مشترك بين خمس وكالات فضاء: ناسا (الولايات المتحدة) و روسكوزموس (روسيا) و جاكسا (اليابان) و إيسا (أوروبا) و وكالة الفضاء الكندية (كندا). علما أنه تم تحديد ملكية واستخدام المحطة الفضائية بموجب المعاهدات والاتفاقيات الحكومية الدولية. كما تعمل محطة الفضاء الدولية كمختبر أبحاث للجاذبية متناهية الصغر والبيئة الفضائية ؛ حيث يجري أفراد الطاقم تجارب مختلفة في علم الأحياء وعلم الأحياء البشري والفيزياء وعلم الفلك والأرصاد الجوية ومجالات أخرى. تعتبر المحطة جهة مناسبة لاختبار أنظمة المركبات الفضائية والمعدات اللازمة للمهام إلى كوكب القمر والمريخ. كما تحافظ على مدار بارتفاع يتراوح بين 330 و 435 كيلومترًا (205 و 270 ميل) عن طريق إعادة المناورات باستخدام محركات وحدة زفيزدا (Zvezda) أو مركبة فضائية زائرة. تدور هذه المحطة حول الأرض في حوالي 92 دقيقة وتكمل 15.5 مدارًا يوميًا.',
		title: 'محطة الفضاء الدولية',
		external_id: 'ISS',
		date: 'November 20, 1998',
		launch_location: 'محطة بايكونور الفضائية، بايكونور، كازاخستان',
		launch_vehicle: 'صاروخ بروتون الروسي'
	},
	Sentinel6: {
		absolutePath: true,
		thumb: 'assets/images/sentinel_6_320x240.jpg',
		url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		id: 1375,
		target: '_blank',
		categories: ['operating', 'sea', 'earth_now'],
		time_in_orbit: Math.floor(Math.abs(timeSentinel6) / 365.25) + ' years : ' + Math.floor(timeSentinel6 % 365.25) + ' day' + (Math.floor(timeSentinel6 % 365.25) > 1 ? 's' : ''),
		description: 'The first of two identical satellites to be launched five years apart, Sentinel-6 Michael Freilich will make high precision ocean altimetry measurements to continue the work previously done by Jason-1, Jason-2/OSTM, and the Jason-3 missions.\n\nA secondary objective is to collect high resolution vertical profiles of temperature and water vapor through the Radio Occultation instrument. This is used to help numerical weather predictions.',
		title: 'Sentinel-6 Michael Freilich',
		external_id: 'Sentinel6',
		date: 'November 10, 2020',
		launch_location: 'Vandenberg Air Force Base',
		launch_vehicle: ''
	},
	sc_saudisat_4: {
		absolutePath: true,
		thumb: 'assets/images/saudisat4.png',
		url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		id: 1374,
		target: '_blank',
		categories: ['operating', 'land', 'earth_now'],
		time_in_orbit: Math.floor(ss4_time / 365.25) + ' سنة ميلادية و ' + Math.floor(ss4_time % 365.25) + ' يوم',
		description: 'مهمة علمية للتحكم في تراكم الشحنات على كتلة اختبار الطفو الحر. نظام AIS كحمولة ثانوية. تم تطوير القمر الصناعي محلياً في مدينة الملك عبدالعزيز للعلوم والتقنية بوزن ١٢٠ كجم. من التقنيات المستخدمة هي: تحكم في الوضعية ثلاثي المحاور، رابط بيانات X-Band، لوحة شمسية ثلاثية التقاطع (خلايا أساسها زرنخيد الغاليون) وبطاريات أيون الليثيوم. القمر الصناعي يوجد في مدار LEO.',
		title: 'سعودي سات ٤',
    status: 1,
		external_id: 'sc_saudisat_4',
		date: 'June 19, 2014',
		launch_location: 'موقع دمباروفسكي ١٣/٣٧٠، روسيا',
		launch_vehicle: 'صاروخ دنيبر '
	}
};

export default SPACECRAFT_DATA_AR;
